import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal, InputGroup } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import CssClass from "../../../Styles/common.module.css";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RegisterOrganization = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const organizationNameInputRef = useRef();
  const formatInputRef = useRef();
  const remarkInputRef = useRef();

  const [dataToBeSelect, setDataToBeSelect] = useState([]);
  const [systemList, setSystemList] = useState([]);

  // const [addData, setAddData] = useState([]);

  const yearFormat = "yyyy";
  const mthFormat = "MM";
  const mthCountFormat = "####";

  const [addData, setAddData] = useState({
    FORMAT_YEAR: {
      key: yearFormat,
      label: yearFormat,
      value: yearFormat,
    },
    FORMAT_MONTH: {
      key: mthFormat,
      label: mthFormat,
      value: mthFormat,
    },
    FORMAT_COUNT: mthCountFormat,
  });

  const [inputError, setInputError] = useState([]);

  //#region Style
  const th = {
    fontWeight: "normal",
  };

  const thInput = {
    fontWeight: "normal",
    border: "1px solid #ced4da",
  };
  //#endregion

  useEffect(() => {
    if (props.dataToBeSelect !== undefined && props.dataToBeSelect !== null) {
      setDataToBeSelect({
        OrganizationCat:
          props.dataToBeSelect.OrganizationCat === null
            ? []
            : props.dataToBeSelect.OrganizationCat,
        System:
          props.dataToBeSelect.System === null
            ? []
            : props.dataToBeSelect.System,
      });
    }
  }, [props.dataToBeSelect]);

  const hideModal = () => {
    setAddData({
      FORMAT_YEAR: {
        key: yearFormat,
        label: yearFormat,
        value: yearFormat,
      },
      FORMAT_MONTH: {
        key: mthFormat,
        label: mthFormat,
        value: mthFormat,
      },
      FORMAT_COUNT: mthCountFormat,
    })
    setSystemList([]);
    // setAddData([]);
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    var flag = true;
    if (addData.ORG_NAME === undefined) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        ORG_NAME: "Organization name could not be empty.",
      }));
    }
    // if (addData.FORMAT === undefined) {
    //   flag = false;
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT: "Ticket number format could not be empty.",
    //   }));
    // }
    // if (addData.FORMAT_ORG === undefined) {
    //   flag = false;
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT_ORG: "could not be empty.",
    //   }));
    // }
    // if (
    //   addData.FORMAT_YEAR === undefined || addData.FORMAT_YEAR === null ||
    //   Object.keys(addData.FORMAT_YEAR).length === 0
    // ) {
    //   flag = false;
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT_YEAR: "Please select a year format.",
    //   }));
    // } else {
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT_YEAR: "",
    //   }));
    // }
    // if (
    //   addData.FORMAT_MONTH === undefined || addData.FORMAT_MONTH === null ||
    //   Object.keys(addData.FORMAT_MONTH).length === 0
    // ) {
    //   flag = false;
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT_MONTH: "Please select a month format.",
    //   }));
    // } else {
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     FORMAT_MONTH: "",
    //   }));
    // }
    if (addData.FORMAT_ORG === undefined || addData.FORMAT_YEAR === undefined || addData.FORMAT_YEAR === null ||
        Object.keys(addData.FORMAT_YEAR).length === 0 || addData.FORMAT_MONTH === undefined || addData.FORMAT_MONTH === null ||
        Object.keys(addData.FORMAT_MONTH).length === 0) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        TICKET_NUM_FORMAT: "Invalid ticket number format."
      }))
    }
    else {
      setInputError((prevState) => ({
        ...prevState,
        TICKET_NUM_FORMAT: "",
      }));
    }
    if (
      addData.ORG_CATEGORY === undefined ||
      Object.keys(addData.ORG_CATEGORY).length === 0
    ) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        ORG_CATEGORY: "Please select a organization category.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        ORG_CATEGORY: "",
      }));
    }
    if (
      Object.keys(systemList).length === 0
    ) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        SYSTEM_USED: "Please select at least one system.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        SYSTEM_USED: "",
      }));
    }
    if (
      Object.values(inputError).filter((v) => v !== "").length === 0 &&
      flag
    ) {
      RegisterOrganization();
    }
  };

  function RegisterOrganization() {
    let functionName = "";
    try {
      functionName = props.page + RegisterOrganization.name;
      props.onLoading(true, "Registering organization, please wait...");
      const selectedSystemList = systemList.map((s) => s.key);
      const data = {
        ORG_NAME: addData.ORG_NAME.trim(),
        ORG_CATEGORY_ID: addData.ORG_CATEGORY.key,
        ORG_CATEGORY_NAME: addData.ORG_CATEGORY.label,
        ORG_SYSTEM_LIST: selectedSystemList,
        FORMAT_ORG: addData.FORMAT_ORG,
        FORMAT_YEAR: addData.FORMAT_YEAR,
        FORMAT_MONTH: addData.FORMAT_MONTH,
        FORMAT_COUNT: addData.FORMAT_COUNT,
        FORMAT: addData.FORMAT_ORG + '-' + addData.FORMAT_YEAR.key + addData.FORMAT_MONTH.key + '-' + addData.FORMAT_COUNT,
        // FORMAT: addData.FORMAT + '-' + dateFormat + '-' + mthCountFormat,
        REMARK: addData.REMARK === undefined ? "" : addData.REMARK.trim(),
        UPDATE_ID: userId,
      };
      http
        .post("api/Organization/RegisterOrg", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.DUPLICATE_ORG_NAME === true && response.data.DUPLICATE_FORMAT === true ) {
            toast.error("Organization and Ticket Number Format already exist.");
          } else if (response.data.DUPLICATE_ORG_NAME === true && response.data.DUPLICATE_FORMAT === false) {
            toast.error("Organization already exist.");
          } else if (response.data.DUPLICATE_ORG_NAME === false && response.data.DUPLICATE_FORMAT === true) {
            toast.error("Ticket Number Format already exist.");
          } else {
            toast.success("Organization is successfully inserted.");
            props.onReload();
            hideModal();
          }          
        })
        .catch((err) => {
          toast.error("Failed to insert organization. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to insert organization. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  
function checkCountFormat(input) {
  for (const char of input) {
      if (char !== "#") {
          return false;
      }
  }
  return true;
}

  const mthCountHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
        // if (checkCountFormat(val) === false) {
        //   setInputError((prevState) => ({
        //     ...prevState,
        //     [id]: "Format: ####",
        //   }));
        // } else {
        //   setInputError((prevState) => ({
        //     ...prevState,
        //     [id]: "",
        //   }));
        // }   
      }  
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const name = event.target.name;
      functionName = inputUnrequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;

      setAddData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setAddData((prevState) => ({
        ...prevState,
        [field]: val, //Document type
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectSystemHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectSystemHandler.name;
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          SYSTEM_USED: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          SYSTEM_USED: "System used could not be empty.",
        }));
      }
      setSystemList([...val]);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>REGISTER</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Input
            ref={organizationNameInputRef}
            id="ORG_NAME"
            label="Organization Name*:"
            name="Organization Name"
            type="text"
            className="form-control"
            errorMessage={inputError.ORG_NAME}
            value={addData.ORG_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Select
            id="ORG_CATEGORY"
            label="Organization Category*:"
            type="text"
            options={dataToBeSelect.OrganizationCat}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.ORG_CATEGORY}
            value={addData.ORG_CATEGORY}
            onChange={(val) => selectionHandler(val, "ORG_CATEGORY")}
          />
          <Comp.Select
            id="SYSTEM_USED"
            label="System Used*:"
            type="text"
            options={dataToBeSelect.System}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.SYSTEM_USED}
            value={systemList}
            onChange={selectSystemHandler}
            isMulti
          />
          {/* <Comp.Input
            ref={formatInputRef}
            id="FORMAT"
            label="Ticket Number Format*:"
            name="Ticket Number Format"
            type="text"
            className="form-control"
            errorMessage={inputError.FORMAT}
            value={addData.FORMAT}
            onChange={inputRequiredHandler}
          /> */}
          <label className={CssClass.colFormLabel}>Ticket Number Format*:</label>
          <div>
            <form>
              <table >
                {/* <thead>
                  <tr>
                      <th style={{textAlign: "center"}}>[Organization]</th>
                      <th>-</th>
                      <th style={{textAlign: "center"}}>[Date Format]</th>
                      <th>-</th>
                      <th style={{textAlign: "center"}}>[Count]</th>      
                  </tr>
                </thead> */}
                <tbody>
                  <tr>
                      <th width={"80px"} style={thInput}>
                        <Comp.Input
                          // ref={formatInputRef}
                          id="FORMAT_ORG"
                          type="text"
                          className="form-control"
                          width="10px"
                          // errorMessage={inputError.FORMAT_ORG}
                          value={addData.FORMAT_ORG}
                          onChange={inputRequiredHandler}
                        />
                      </th>
                      <th style={th}>-</th>
                      <th width={"130px"} style={thInput}>
                        <Comp.Select
                          id="FORMAT_YEAR"    
                          closeMenuOnSelect={true}
                          isClearable={true}
                          hideSelectedOptions={false}
                          options={[
                            {
                              key: "yy",
                              value: "yy",
                              label: "yy"
                            },
                            {
                              key: "yyyy",
                              value: "yyyy",
                              label: "yyyy"
                            },
                          ]}
                          // errorMessage={inputError.FORMAT_YEAR}
                          value={addData.FORMAT_YEAR}
                          onChange={(val) => selectionHandler(val, "FORMAT_YEAR")}
                        />
                        {/* <Comp.Input
                          id="FORMAT_YEAR"
                          value={addData.FORMAT_YEAR}
                          // readOnly={true}
                        /> */}
                      </th>
                      <th width={"160px"} style={thInput}>
                      <Comp.Select
                          id="FORMAT_MONTH"    
                          // options={dataToBeSelect.Organization}
                          closeMenuOnSelect={true}
                          isClearable={true}
                          hideSelectedOptions={false}
                          options={[
                            {
                              key: "M",
                              value: "M",
                              label: "M"
                            },
                            {
                              key: "MM",
                              value: "MM",
                              label: "MM"
                            },
                            {
                              key: "MMM",
                              value: "MMM",
                              label: "MMM"
                            },
                            {
                              key: "MMMM",
                              value: "MMMM",
                              label: "MMMM"
                            },
                          ]}
                          // errorMessage={inputError.FORMAT_MONTH}
                          value={addData.FORMAT_MONTH}
                          onChange={(val) => selectionHandler(val, "FORMAT_MONTH")}
                        />
                        {/* <Comp.Input
                          id="FORMAT_MONTH"
                          value={addData.FORMAT_MONTH}
                          // readOnly={true}
                        /> */}
                      </th>
                      <th style={th}>-</th>
                      <th width={"80px"} style={thInput}>
                        <Comp.Input
                          id="FORMAT_COUNT"
                          value={addData.FORMAT_COUNT}
                          // errorMessage={inputError.FORMAT_COUNT}
                          onChange={mthCountHandler}
                          readOnly={true}
                        />      
                      </th>   
                  </tr>
                </tbody>
              </table>
            </form>
            {inputError.TICKET_NUM_FORMAT != ""  && (
              <div className={CssClass.invalidMessage}>{inputError.TICKET_NUM_FORMAT}</div>
            )}
          </div>
          <Comp.Input
            ref={remarkInputRef}
            id="REMARK"
            label="Remark:"
            type="text"
            className="form-control"
            value={addData.REMARK}
            onChange={inputUnrequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegisterOrganization;
